/**
 * External dependencies
 */
import React from "react";
import classnames from "classnames";
/**
 * Internal dependencies
 */
import AngleCircle from "./angle/angle";
import "./angle/style.scss";
import NumberInput from "./number";
import { INPUT_LIMITS } from "../input-limits";

function AngleInput({ className, label = "", onChange, value }) {
  const handleOnNumberChange = (unprocessedValue) => {
    const inputValue =
      unprocessedValue !== "" ? parseInt(unprocessedValue, 10) : 0;
    onChange(inputValue);
  };

  const classes = classnames(
    "grigora-angle-picker-input flex gap-3",
    className,
  );

  return (
    <div className={classes}>
      {label && (
        <span className="grigora-select-input__label text-grigora-base flex flex-1 select-none text-editor-text-main items-center">
          {label}
        </span>
      )}
      <NumberInput
        isResetVisible={false}
        label={label}
        className="grigora-angle-picker-input__input-field "
        // max={360}
        // min={0}
        min={INPUT_LIMITS["angle-input"].min}
        max={INPUT_LIMITS["angle-input"].max}
        onChange={handleOnNumberChange}
        // step="1"
        step={INPUT_LIMITS["angle-input"].step}
        value={parseInt(value)}
        spinControls="none"
        addonAfter={<div>°</div>}
      />
      <div className="grigora-angle-picker__container">
        <AngleCircle aria-hidden="true" value={value} onChange={onChange} />
      </div>
    </div>
  );
}

export default AngleInput;
